module.exports = "/virtual-football-league/img/amblems/right/logos/FakeFulham.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/FakeFulham.png
// module id = 2175
// module chunks = 4